import React, { useState } from 'react';
import DownloadOptions from './DownloadOptions';

function ImagePreview({ image, onClose }) {
  const [zoom, setZoom] = useState(1);
  
  const handleZoomIn = () => {
    setZoom(prev => Math.min(prev + 0.1, 2));
  };
  
  const handleZoomOut = () => {
    setZoom(prev => Math.max(prev - 0.1, 0.5));
  };

  return (
    <div className="image-preview-overlay">
      <div className="image-preview-container">
        <button className="close-button" onClick={onClose}>×</button>
        
        <div className="preview-image-container">
          <img 
            src={image.fullUrl} 
            alt={`${image.name} - Full size preview`}
            className="preview-image"
            style={{ transform: `scale(${zoom})` }}
          />
        </div>
        
        <div className="preview-controls">
          <div className="zoom-controls">
            <button onClick={handleZoomOut}>-</button>
            <span>{Math.round(zoom * 100)}%</span>
            <button onClick={handleZoomIn}>+</button>
          </div>
          
          <DownloadOptions image={image} />
        </div>
      </div>
    </div>
  );
}

export default ImagePreview;